import { Link } from "react-router-dom";
import { BRAND } from "../lib/constants";

export const LogoMark = ({ withWordmark = true, size = "md", className = "" }) => {
  const dim =
    size === "lg" ? "h-14 w-14" : size === "sm" ? "h-10 w-10" : "h-12 w-12";
  return (
    <Link
      to="/"
      data-testid="brand-logo-link"
      className={`group flex items-center gap-3 ${className}`}
      aria-label={BRAND.name}
    >
      <span
        className={`relative ${dim} shrink-0 overflow-hidden rounded-md ring-1 ring-gold/30 transition-all duration-500 group-hover:ring-gold/70 group-hover:shadow-[0_0_24px_rgba(212,175,55,0.35)]`}
      >
        <img
          src={BRAND.logoUrl}
          alt="Beyond Borders Travel logo"
          className="h-full w-full object-cover"
          loading="eager"
        />
      </span>
      {withWordmark && (
        <span className="leading-none hidden sm:block">
          <span className="block font-display text-[15px] sm:text-[17px] font-semibold tracking-wide text-white">
            Beyond <span className="gold-text">Borders</span>
          </span>
          <span className="mt-1.5 block text-[10px] uppercase tracking-[0.42em] text-white/50">
            Travel
          </span>
        </span>
      )}
    </Link>
  );
};

export default LogoMark;
